import React from "react";
import { Row } from "react-bootstrap";
//Services
import Api from "../../../services/api";
//Components
import Button from "../../../Components/commonButton/commonButton";
import TextField from "../../../Components/textField/textField";
import Alert from "../../../Components/alert/Alert";
import Validation from "../../../Components/validation/validation";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
//Styles
import "../general.css";
import "./factory.css";

export default class  AddFactory extends React.Component {

  state = {
    show: false,
    description: null,
    id: null,
    message: "",
    reload: false,
    render:false,
    notification: false,
    notification_type: 'success',
    notification_message: ''
  };

  callBack = (child) => {
    
    this.setState({ description: child });
  };

  sendData = () => {
    if (this.state.description !== null && this.state.description != "") {
      Api.post("/factorys/", {
        description: this.state.description,
      })
        .then((res) => {
          this.setState({notification: true, notification_message: "Planta cadastrada com sucesso!"});
          setTimeout(()=>{
            return window.location.reload();
          },2000)
        })
        .catch((err) => {
          if (err.response.status === 400)
            this.setState({
              message: "" + err.response.data.response,
              show: true,
            });

          if (err.response.status === 500)
            this.setState({
              message: "" + err.response.data.response,
              show: true,
            });
        });
    } else {
      this.setState({
        message: "Necessário preencher todos os campos.",
        show: true,
      });
    }
  };

  callbackfunction = () => {
    this.setState({ show: false });
  };

  componentDidMount = async () =>{
    await setTimeout(() => {
      this.setState({render:true})
    }, 3500);
  }
  render() {
    let { show, message, reload, notification, notification_type,notification_message } = this.state;

    return (
      <Row className="box w-100">
      <div className='cont_add_fac form'>
      <h4>Adicionar Planta</h4>
        <div className="inputs">
          
          {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}

          {show ? (
            <Alert
              show={show}
              message={message}
              parentCallback={this.callbackfunction}
              reload={reload}
            />
          ) : null}
          <div className="element" id="factoryText">
            <TextField
              section={false}
              focus={true}
              title="Descrição da planta"
              min={3}
              max={30}
              validationType="varchar"
              parentCallback={this.callBack}
            />
          </div>
          </div>
        <div className="addFacBtn submitButton">
          <Button title="Adicionar" className="btn-fixed" icon="add" parentCallback={this.sendData} />
        </div>
      </div>
      {Validation()}
      </Row>
    );
  };
}